/* eslint-disable no-restricted-syntax */
import redirects from '@/fish/router/redirects'
import global from '@/fish/router/global'
import sharedGlobal from '@/router/global'
import { createRouter, createWebHistory } from 'vue-router'
import { addBreadcrumb } from '@sentry/vue'
import { paramHandler } from '@/router/params'

import {
  hasValidUserSession,
  isEmployee,
  signinRedirect,
} from '@/services/identity-client'
import { log } from '@/services/logging-service'
import {
  redirectToLogin,
  showLandingPagePreview,
} from '@/router/shared/login-route'
import { AppSetupBeforeEnter } from '@/router/shared'
import split from '@/lib/split'

const router = createRouter({
  history: createWebHistory(),
  routes: [...sharedGlobal, ...global, ...redirects],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.path !== from.path) {
      return { x: 0, y: 0 }
    }
  },
})

router.beforeEach(paramHandler)

// Store requested route for use in error handling
let beforeEachLastTo
router.beforeEach(AppSetupBeforeEnter())
router.beforeEach(async (to, from) => {
  performance.mark('start_before_each_route')
  // Add breadcrumb that will show up if exception is encountered during navigation
  addBreadcrumb({
    category: 'navigation',
    message: JSON.stringify({ from: from.fullPath, to: to.fullPath }),
  })
  beforeEachLastTo = to
  const validSession = await hasValidUserSession()
  // Authentication guard - Checks if the route has a `meta.preAuthRoute` field and requires Auth if not.
  if (!to.matched.some((route) => route.meta.preAuthRoute) && !validSession) {
    await split.splitClientsReady()
    if (showLandingPagePreview(to)) {
      return redirectToLogin(to)
    }
    return signinRedirect({
      state: {
        after_login: to.fullPath,
      },
    })
  } else if (
    to.matched.some((route) => route.meta.employeeRoute) &&
    !(await isEmployee())
  ) {
    const parentRoute = to.matched[0]
    return parentRoute
  }
  performance.mark('end_before_each_route')
  performance.measure(
    'before_each_route_fish',
    'start_before_each_route',
    'end_before_each_route'
  )
})

router.onError((error) => {
  // Log chunk loading errors to both firebase analytics and Sentry for
  // comparison
  if (error.name === 'ChunkLoadError') {
    const requestedRoute = beforeEachLastTo?.fullPath ?? 'n/a'
    log('ChunkLoadError', {
      route: window.location.origin + requestedRoute,
      request: error.request,
      type: error.type,
    })
  }
})

export default router
